/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterOci extends models.ServiceAccountCredentialsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterOci");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterOci.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterOci>): ServiceAccountCredentialsForKubernetesClusterOci {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterOci(), model);
        ServiceAccountCredentialsForKubernetesClusterOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterOci>): ServiceAccountCredentialsForKubernetesClusterOci {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterOci.newInstance(<ServiceAccountCredentialsForKubernetesClusterOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterOci) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterOci): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Auth User Id. This is a required field.
     */
    user: string;

    /**
     * Key Fingerprint. This is a required field.
     */
    fingerprint: string;

    /**
     * Private Key. This is a required field.
     */
    private_key: string;

}
